import styled from 'styled-components/macro'

export const ErrorPopupSc = styled.div.attrs((style) => ({ ...style }))`
  color: #ff335c;
  font-size: 14px;
  grid-area: error;
  justify-self: start;
`
